import { render } from "./SuccessErrorMessage.vue?vue&type=template&id=4ddce882"
import script from "./SuccessErrorMessage.vue?vue&type=script&lang=js"
export * from "./SuccessErrorMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__